const API_URL = process.env.REACT_APP_API_SOURCE;

// Funkcja pomocnicza do zapytań
const fetchApi = async (endpoint, options = {}) => {
    const token = localStorage.getItem("token");
    const headers = {
        "Content-Type": "application/json",
        ...options.headers,
    };
    if (token) {
        headers["Authorization"] = `Token ${token}`;
    }

    const response = await fetch(`${API_URL}${endpoint}`, { ...options, headers });

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`API Error (${response.status}): ${errorText}`);
    }
    return response.json();
};

// Eksportowane funkcje dla każdej operacji
export const fetchUserStatus = () => fetchApi("ai-status/");

export const submitProblemAttempt = (attemptData) => fetchApi("solve_problem_attempt/", {
    method: "POST",
    body: JSON.stringify(attemptData),
});

export const fetchNextProblems = () => fetchApi("continue_solve_problems/", {
    method: "POST",
});

export const decrementAiCalls = () => fetchApi("ai-decrement-calls/", {
    method: "POST",
});